import {Button, Form, Modal} from "react-bootstrap";
import InputField from "../../components/InputField";
import {useEffect, useMemo, useRef, useState} from "react";
import useTranslation from "../../hooks/translations";
import {useApi} from "../../contexts/ApiProvider";
import CurrencyService from "../../services/CurrencyService";

export default function CurrencyModal({
                                        showModal,
                                        title,
                                        data,
                                        onModalSubmit,
                                        onModalClose
                                      }) {
  const nameField = useRef();
  const symbolField = useRef();
  const [formErrors, setFormErrors] = useState({});
  const translations = useTranslation();
  const api = useApi()
  const currencyService = useMemo(() => new CurrencyService(api), [api]);

  useEffect(() => {
    if (Object.keys(data).length > 0) {
      nameField.current.value = data.name;
      symbolField.current.value = data.symbol;
    } else {
      nameField.current.focus();
    }

  }, [data]);

  const handleClose = () => {
    onModalClose()
  };

  const onSubmit = async (event) => {
    event.preventDefault();
    const name = nameField.current.value;
    const symbol = symbolField.current.value;

    const errors = {};
    if (!name) {
      errors.name = translations.errorName;
    }
    if (!symbol) {
      errors.symbol = translations.errorSymbol;
    }
    setFormErrors(errors);

    if (Object.keys(errors).length > 0) {
      return;
    }

    const submitData = {name, symbol}

    if (data.id) {
      const response = await currencyService.put(data.id, submitData)
      if (!response.ok) {
        return
      }
    } else {
      const response = await currencyService.create(submitData)
      if (!response.ok) {
        return
      }
    }

    onModalSubmit(submitData)
  }

  return (
    <Modal show={showModal} onHide={handleClose}>
      <Modal.Header closeButton>
        <Modal.Title>{title ? title : translations.currency}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form onSubmit={onSubmit} id="currencyForm">
          <div className="mb-3">
            <InputField
              name="inputName"
              label={translations.name}
              placeholder={translations.enterName}
              error={formErrors.name}
              fieldRef={nameField}
            />
          </div>
          <div className="mb-3">
            <InputField
              name="inputSymbol"
              label={translations.symbol}
              placeholder={translations.enterSymbol}
              error={formErrors.symbol}
              fieldRef={symbolField}
              maxLength={10}
            />
          </div>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="primary" type="submit"
                form="currencyForm">{translations.save}</Button>
        <Button variant="secondary"
                onClick={handleClose}>{translations.close}</Button>
      </Modal.Footer>
    </Modal>
  )
}
